import { useEffect, useState } from "react";
import StaticTemplate from "./StaticTemplate/StaticTemplate";
import { Button, Card, Space, Modal } from "antd";
import {
  AfterEffectskIcon,
  BookIcon,
  AIIcon,
} from "../../icons-and-animations/icons";
import "./welcome.scss";

import {
  ProjectsHOCWrapper,
  ProjectsListProps,
} from "../ProjectsList/ProjectsWrapper";
import LottieLoader from "../../components/LottieLoader";
import CardsGallery from "../../components/CardsGallery/CardsGallery";
import { useNavigate } from "react-router-dom";
import { PATHS, toPath } from "../../PATHS";
import {
  ttvStaticContent,
  aeStaticContent,
} from "./StaticTemplate/StaticContent";

const fallbackData =
  "data:image/png;base64,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";
const handleImageError = (e: any) => {
  e.target.src = fallbackData;
};

const WelcomeProjectsGallery = (props: ProjectsListProps) => {
  const { isLoading, projects, userHasMultipleAccounts } = props;

  const [isTTVModalVisible, setIsTTVModalVisible] = useState(false);
  const [isAEModalVisible, setIsAEModalVisible] = useState(false);

  const navigate = useNavigate();

  const options = [
    {
      title: "Browse Use Cases",
      subtitle: "Get inspired using templates ",
      icon: <BookIcon />,
      class: "browse",
      onClick: () => {
        navigate(toPath(PATHS.useCases));
      },
    },
    {
      title: "Wireframe using AI",
      subtitle: "Convert text into engaging videos",
      icon: <AIIcon />,
      class: "ai",
      onClick: () => {
        setIsTTVModalVisible(true);
      },
    },
    {
      title: "Build with Full flexibility",
      subtitle: "Use Blings’ After Effects extension",
      icon: <AfterEffectskIcon />,
      class: "after-effects",
      onClick: () => {
        setIsAEModalVisible(true);
      },
    },
  ];

  const navigateToPath = (projectId: string) => {
    navigate(toPath(PATHS.project, projectId));
  };

  return (
    <>
      {isLoading ? (
        <LottieLoader />
      ) : (
        <div className="welcome-container">
          <div className="welcome-header">
            <h1>Welcome To Blings!</h1>
            <p className="subtitle">Create, manage and track your projects</p>
          </div>
          <Card className="journey-card" variant="borderless">
            <div className="journey-content">
              <div className="left-content">
                <div className="journey-text">
                  <h2>Introduce your brand on a personal level.</h2>
                  <Space
                    direction="vertical"
                    size="large"
                    className="checklist"
                  >
                    <div className="checklist-item">
                      <span>Build a video first welcome funnel</span>
                    </div>
                    <div className="checklist-item">
                      <span>Collect Data on your users (e.g., birthdate)</span>
                    </div>
                    <div className="checklist-item">
                      <span>Gain highly engaged new members</span>
                    </div>
                  </Space>
                </div>
                <Button
                  type="primary"
                  className="create-usecase-button"
                  onClick={() => navigate(toPath(PATHS.useCases))}
                >
                  Start With Welcome Template
                </Button>
              </div>
            </div>
            <img
              src={"https://assets.blings.io/projects/welcome_banner.png"}
              alt="Phone Interface"
              className="phone-mockup"
              onError={handleImageError}
            />
          </Card>

          {/* <div className="get-started-section">
            <h3>
              {projects.length === 0 ? (
                <p>
                  <strong>Let's get started!&nbsp;</strong> Select how you want
                  to create your first project.
                </p>
              ) : (
                <p>
                  <strong>Quick Actions</strong>
                </p>
              )}
            </h3>

            <div className="options-grid">
              {options.map((option, index) => (
                <div
                  key={index}
                  className={"option-card " + option.class}
                  onClick={option.onClick}
                >
                  <div className="option-content">
                    <span className="icon">{option.icon}</span>
                    <div className="option-text">
                      <span>{option.title}</span>
                      <span className="subtitle">{option.subtitle}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
          {projects.length === 0 ? (
            <div></div>
          ) : (
            <CardsGallery
              items={projects}
              userHasMultipleAccounts={userHasMultipleAccounts}
              handleClick={navigateToPath}
              cardType="project"
              getItemName="title"
            />
          )}
        </div>
      )}

      <Modal
        width={900}
        style={{ borderRadius: 20, overflow: "auto" }}
        centered
        footer={null}
        destroyOnHidden={true}
        open={isTTVModalVisible}
        onOk={() => setIsTTVModalVisible(false)}
        onCancel={() => setIsTTVModalVisible(false)}
        okText="Ok"
        cancelText="Cancel"
      >
        <StaticTemplate props={ttvStaticContent.props} />
      </Modal>

      <Modal
        width={900}
        style={{ borderRadius: 20, overflow: "auto" }}
        centered
        footer={null}
        destroyOnHidden={true}
        open={isAEModalVisible}
        onOk={() => setIsAEModalVisible(false)}
        onCancel={() => setIsAEModalVisible(false)}
        okText="Ok"
        cancelText="Cancelar"
      >
        <StaticTemplate props={aeStaticContent.props} />
      </Modal>
    </>
  );
};

export default ProjectsHOCWrapper(WelcomeProjectsGallery);
